import { render, staticRenderFns } from "./QualificationNew.vue?vue&type=template&id=96611902"
import script from "./QualificationNew.vue?vue&type=script&lang=js"
export * from "./QualificationNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports